import React from 'react';
import { Link } from 'react-router-dom';
import { Lightning } from '@phosphor-icons/react';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background text-foreground p-6">
      <div className="max-w-3xl mx-auto pt-12">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <Lightning size={22} weight="fill" className="text-foreground" />
          <span className="font-heading text-lg font-bold text-foreground">Mayr Lead Creator</span>
        </Link>
        <h1 className="font-heading text-3xl font-bold text-foreground mb-6">Terms of Service</h1>
        <div className="prose prose-sm text-muted-foreground space-y-4">
          <p>These Terms of Service govern your use of the Mayr Lead Creator platform operated by Mayr-Technologies.</p>
          <p>By creating an account, you agree to use this platform for legitimate B2B lead discovery and outreach purposes only. You agree not to use the platform for spam, harassment, or any activity that violates applicable laws.</p>
          <p>We reserve the right to suspend or terminate accounts that violate these terms.</p>
          <p className="text-xs text-muted-foreground mt-8">Last updated: April 2026. Full terms will be published before general availability.</p>
        </div>
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground underline mt-8 block">Back to home</Link>
      </div>
    </div>
  );
}
